import { render, staticRenderFns } from "./DeleteItemConfirmModal.vue?vue&type=template&id=2cb1e2a6&"
import script from "./DeleteItemConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteItemConfirmModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteItemConfirmModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports